import { API } from "./axiosInstance"

/**
 * Gets all the users with joined tables from usermanagement-service
 * @returns the users with joined objects
 */
export const getUsers = async () => {
    const users = await API.get(`/users?isDeleted=0`);
    return users.data;
}

/**
 * Calls the post users endpoint
 * @param {*} user the user to create
 * @returns the response from usermanagement-service
 */
export const createUser = async (user) => {
    const createdUser = await API.post('/users', user);
    return createdUser;
}

/**
 * Gets all the users with joined tables for one usergroup from usermanagement-service
 * @param {*} staticUserGroupId The static usergroup to get all the users for
 * @returns the users with joined objects
 */
export const getUsersForUserGroup = async (staticUserGroupId) => {
    const users = await API.get(`/users?userGroupId=${staticUserGroupId}&isDeleted=0`);
    return users.data;
}

/**
 * Calls the update user endpoint
 * @param {*} user the user to update
 * @returns the updated user
 */
export const updateUser = async(user, staticId) => {
    const updatedUser = await API.put(`/users/${staticId}`, user);
    return updatedUser;
}

/**
 * Accepts a requested change for a user
 * @param {*} staticId the id of the user in the static model
 * @param {*} body optional body for the accept call.
 * @returns the accepted user
 */
export const acceptChange = async(staticId, body = null) => {
    const response = await API.post(`/users/${staticId}/accept`, body);
    return response.data;
}

/**
 * Rejects a requested change for a user
 * @param {*} staticId the id of the user in the static model
 * @returns the rejected user
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/users/${staticId}/reject`);
    return response.data;
}

/**
 * Calls the get userInfo endpoint
 * @returns the userInfo
 */
export const getUserInfo = async () => {
    const userInfo = await API.get(`/userInfo`);
    return userInfo;
}
